import {
  APP_RESOURCES_REQUEST,
  APP_RESOURCES_SUCCESS,
  APP_RESOURCES_FAILURE,
  APP_ACTIONS_REQUEST,
  APP_ACTIONS_SUCCESS,
  APP_ACTIONS_FAILURE,
  APP_SETTINGS_REQUEST,
  APP_SETTINGS_SUCCESS,
  APP_SETTINGS_FAILURE,
} from './types';

const initialState = {
  list: [],
  loading: false,
  error: false,
  current: false,
};

export default function reducer(state = { ...initialState }, action = {}) {
  switch (action.type) {
    case APP_RESOURCES_REQUEST:
      return { ...state, loading: true, error: false, list: [] };
    case APP_RESOURCES_FAILURE:
      return { ...state, error: action.payload, loading: false };
    case APP_RESOURCES_SUCCESS:
      return { ...state, list: action.payload, loading: false, error: false };
    default:
      return state;
  }
}

export const productActions = (state = { ...initialState }, action = {}) => {
  switch (action.type) {
    case APP_ACTIONS_REQUEST:
      return { ...state, loading: true, error: false, list: [] };
    case APP_ACTIONS_FAILURE:
      return { ...state, error: action.payload, loading: false };
    case APP_ACTIONS_SUCCESS:
      return { ...state, list: action.payload, loading: false, error: false };
    default:
      return state;
  }
};

export const productSettings = (state = { ...initialState }, action = {}) => {
  switch (action.type) {
    case APP_SETTINGS_REQUEST:
      return { ...state, loading: true, error: false, value: false };
    case APP_SETTINGS_FAILURE:
      return { ...state, error: action.payload, loading: false };
    case APP_SETTINGS_SUCCESS:
      return { ...state, value: action.payload, loading: false, error: false };
    default:
      return state;
  }
};
